export default function emptyCache() {
  if ('caches' in window) {
    caches.keys().then(names => {
      // Delete all the cache files
      names.forEach(name => {
        caches.delete(name);
      });
    });

    // Makes sure the page reloads. Changes are only visible after you refresh.
    // window.location.reload(true);
  }
}

const TOKEN_KEY = 'user_token';

// The only owner of the login token; everything else reads it from here.
export const auth = {
  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },
  getToken() {
    return localStorage.getItem(TOKEN_KEY) || null;
  },

  // Logout in another tab removes the shared token; follow it.
  watchLogoutInOtherTabs() {
    window.addEventListener('storage', (event) => {
      if (event.key === TOKEN_KEY && !event.newValue) {
        window.location.replace('/login');
      }
    });
  },

  logout() {
    // Without this, Google One Tap silently signs the user straight back in.
    window.google?.accounts?.id?.disableAutoSelect();
    emptyCache();
    // Remove the token before clear(): other tabs watch this key (watchLogoutInOtherTabs).
    localStorage.removeItem(TOKEN_KEY);
    localStorage.clear(); // Also drops persisted Redux state
  },
};
